<h1>Verträge</h1>
<table mat-table [dataSource]="allContracts" class="mat-elevation-z8">
  <ng-container matColumnDef="id">
    <th class="small-header" mat-header-cell *matHeaderCellDef> ID</th>
    <td mat-cell *matCellDef="let element">
      <button cdkCopyToClipboard="{{element.id}}" mat-icon-button aria-label="Kopieren">
        <mat-icon>content_copy</mat-icon>
      </button>
      {{element.id.substring(0, 6)}}...
    </td>
  </ng-container>
  <ng-container matColumnDef="customer">
    <th mat-header-cell *matHeaderCellDef> Kunde</th>
    <td mat-cell *matCellDef="let element"> {{element.customer?.name}} </td>
  </ng-container>
  <ng-container matColumnDef="system">
    <th mat-header-cell *matHeaderCellDef> System</th>
    <td mat-cell *matCellDef="let element"><span *ngFor="let system of element.systems">{{system.name}}<br></span></td>
  </ng-container>
  <ng-container matColumnDef="customerReference">
    <th mat-header-cell *matHeaderCellDef> Referenz</th>
    <td mat-cell *matCellDef="let element"> {{element.customerReference}} </td>
  </ng-container>
  <ng-container matColumnDef="invoiceUnit">
    <th mat-header-cell *matHeaderCellDef> Rechnungseinheit</th>
    <td mat-cell *matCellDef="let element"> {{element.invoiceUnit}} </td>
  </ng-container>
  <ng-container matColumnDef="productType">
    <th mat-header-cell *matHeaderCellDef> Produkt</th>
    <td mat-cell *matCellDef="let element"> {{element.productType}} </td>
  </ng-container>
  <ng-container matColumnDef="additionalFeatures">
    <th mat-header-cell *matHeaderCellDef> Zusätzl. Features</th>
    <td mat-cell *matCellDef="let element"><span
      *ngFor="let feature of element.additionalFeatures">{{feature.additionalFeature.name}}<br></span></td>
  </ng-container>
  <ng-container matColumnDef="basicCharge">
    <th mat-header-cell *matHeaderCellDef> Grundgebühr</th>
    <td mat-cell *matCellDef="let element"> {{helper.centToEuro(element.basicCharge)}} </td>
  </ng-container>
  <ng-container matColumnDef="amount">
    <th mat-header-cell *matHeaderCellDef> Anzahl Lizenzen</th>
    <td mat-cell *matCellDef="let element"> {{element.amount}} </td>
  </ng-container>
  <ng-container matColumnDef="usedLicenses">
    <th mat-header-cell *matHeaderCellDef> Benutzte Lizenzen</th>
    <td
      [ngClass]="{'license-warning-orange': (countLicenses(element) / element.amount) * 100 >= 90 && (countLicenses(element) / element.amount) * 100 < 100,
      'license-warning-red':(countLicenses(element) >= element.amount) }"
      mat-cell
      *matCellDef="let element"> {{countLicenses(element) || 0}}</td>
  </ng-container>
  <ng-container matColumnDef="unitPrice">
    <th mat-header-cell *matHeaderCellDef> Einzelpreis</th>
    <td mat-cell *matCellDef="let element"> {{helper.centToEuro(element.unitPrice)}} </td>
  </ng-container>
  <ng-container matColumnDef="billingInterval">
    <th mat-header-cell *matHeaderCellDef> Abrechnungsintervall</th>
    <td mat-cell *matCellDef="let element"> {{element.billingInterval}} </td>
  </ng-container>
  <ng-container matColumnDef="discountInPercent">
    <th mat-header-cell *matHeaderCellDef> Rabatt in %</th>
    <td mat-cell *matCellDef="let element"> {{element.discountInPercent}} %</td>
  </ng-container>
  <ng-container matColumnDef="startOfContract">
    <th mat-header-cell *matHeaderCellDef> Vertragsbeginn</th>
    <td mat-cell *matCellDef="let element"> {{element.startOfContract}} </td>
  </ng-container>
  <ng-container matColumnDef="earnings">
    <th mat-header-cell *matHeaderCellDef> Umsatz</th>
    <td mat-cell *matCellDef="let element"><span [innerHTML]="getVolume(element)"></span></td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<br>
<mat-paginator [length]="length"
               [pageSize]="pageSize"
               [pageSizeOptions]="[5, 10, 25, 100]"
               (page)="pageEvent = $event; onPaginateChange($event)">
</mat-paginator>
<!--<button mat-fab color="primary" (click)="(openEditDialog())" aria-label="Vertrag erstellen">-->
<!--  <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="add"></mat-icon>-->
<!--</button>-->
